import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Card } from "antd";
import { OrderedMap, Map, List } from "immutable";
// import cx from "classnames";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import shortID from "uuid/v4";
import {
    INPUT_TYPES, COMPANY_TYPES,
    GENDER_TYPES,
    NATURE_OF_ASSOCIATION_TYPES,
    BANK_ACCOUNT_TYPES,
    CORPORATION_TYPE
} from "constants/index";
import { CompanyService } from "services/index";

const getFormFields = ({
    gstinValidator,
    allFieldsDisabled,
    // gstinDisabled
}) =>
    new OrderedMap({
        gstin: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "GSTIN",
            placeholder: "29ABCDE1234F2Z2",
            hasFeedback: true,
            rules: [
                gstinValidator,
                {
                    required: true,
                    message: "GSTIN is Required"
                },
            ],
            // disabled: allFieldsDisabled || gstinDisabled,
            category: 1
        },
        name: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Name",
            rules: [
                {
                    required: true,
                    message: "Name is Required"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1
        },
        type: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Type",
            options: new Map({
                Anchor: 1,
            }).map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            rules: [
                {
                    required: true,
                    message: "Type is Required"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1
        },
        corporation_type: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Corporation Type",
            options: CORPORATION_TYPE.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            rules: [
                {
                    required: true,
                    message: "Corporation Type is Required"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1
        }
    });

const getBasicDetails = ({
    formatSellerData,
    allFieldsDisabled,
    getChannelProducts,
    salesManagers,
    fetchIndustryTypes,
    formatIndustryData,
    formatPrimaryAnchorData
}) => new OrderedMap({
    channel_products: {
        className: "form-field fb-30 mr-3perc",
        label: "Primary Brands",
        type: INPUT_TYPES.OBJECT_SELECT,
        getOptionsOnFocus: getChannelProducts,
        labelProp: "name|id",
        mode: "multiple",
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
        filterOption: true,
        disabled: allFieldsDisabled,
        category: 1
    },
    is_also_anchor: {
        label: "Is Anchor Itself?",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }],
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ]
    },
    all_industries: {
        className: "form-field fb-30 mr-3perc",
        label: "All industries",
        type: INPUT_TYPES.OBJECT_SELECT,
        getOptionsOnFocus: fetchIndustryTypes,
        labelProp: "name",
        mode: "multiple",
        filterOption: true,
        disabled: allFieldsDisabled,
        showSearch: true,
        onSearch: fetchIndustryTypes
    },
    all_anchors: {
        label: "All Anchors",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-30 w-33 mr-3perc",
        disabled: allFieldsDisabled,
        showSearch: true,
        mode: "multiple",
        labelProp: "name",
        onFocus: (e) => e,
        // formatData: formatSellerData,
        // onSearch: (str) => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"), str)
    },
    industry: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        label: "Primary Industry",
        disabled: allFieldsDisabled,
        category: 1,
        labelProp: "name",
        filterOption: true,
        // dataSource: 
        onFocus: (e) => e,
        getOptionsOnFocus: fetchIndustryTypes,
        formatData: formatIndustryData,
        onSearch: fetchIndustryTypes
    },
    anchor: {
        label: "Primary Anchor",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-30 mr-3perc",
        disabled: allFieldsDisabled,
        showSearch: true,
        labelProp: "name",
        onFocus: (e) => e,
        getOptionsOnFocus: (str) => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"), str),
        formatData: formatPrimaryAnchorData,
        onSearch: (str) => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"), str)
    },
    sellers: {
        label: "Sellers",
        type: INPUT_TYPES.OBJECT_SELECT,
        notFoundContent: "This Seller doesn't exist, you need to create it.",
        className: "form-field fb-30 mr-3perc",
        disabled: allFieldsDisabled,
        showSearch: true,
        labelProp: "name",
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ],
        formatData: formatSellerData,
        mode: "multiple",
        onSearch: (str) => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Distributor"), str)
    },
    primary_relationship_manager: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "full_name",
        showSearch: true,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
        onSearch: salesManagers,
        getOptionsOnFocus: salesManagers,
        label: "Primary Relationship Manager",
        disabled: allFieldsDisabled,
        category: 1,
        filterOption: true
    },
    bank: {
        className: "form-field fb-30 mr-3perc",
        label: "Lending Partner",
        type: INPUT_TYPES.SELECT,
        showSearch: true,
        options: new List([
            { label: "Muthoot Finance Limited", value: 4 },
            { label: "Jana Small Finance Bank", value: 6 },
            { label: "Not sure right now", value: 0 }
        ]),
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    is_also_aligned: {
        label: "Is Anchor Aligned?",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }],
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ]
    },
    additional_product_applicable: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Addtional Product Applicable",
        options: new Map({
            Vendor_Finance:2,
            Term_Loan: 7,
            CEP: 8,
        }).map((value, label) => ({
            label: label.split("_").join(" "),
            value: value
        }))
            .toList()
            .toArray(),
        mode: "multiple",
        disabled: allFieldsDisabled,
        category: 1
    }
});

const getUserDetails = (allFieldsDisabled) => new OrderedMap({
    first_name: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "First Name",
        disabled: allFieldsDisabled,
        rules: [
            {
                required: true,
                message: "First Name is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    last_name: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Last Name",
        rules: [
            {
                required: true,
                message: "Last Name is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ],
        disabled: allFieldsDisabled
    },
    email: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Email",
        rules: [
            {
                required: true,
                message: "E-mail is Required"
            },
            {
                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Enter valid Email"
            }
        ],
        disabled: allFieldsDisabled
    },
    phone: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Mobile Number",
        rules: [
            {
                required: true,
                message: "Mobile Number is Required"
            },
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            },
        ],
        disabled: allFieldsDisabled
    },
    gender: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Gender",
        rules: [
            {
                required: true,
                message: "Gender is Required"
            }
        ],
        options: GENDER_TYPES.map((value, label) => ({ value: String(value), label })).toList().toArray(),
        disabled: allFieldsDisabled
    },
    nature_of_association: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Relationship with Company",
        rules: [
            {
                required: true,
                message: "Relationship with Company is Required"
            }
        ],
        options: NATURE_OF_ASSOCIATION_TYPES.map((value, label) => ({
            label,
            value: String(value)
        })).toList().toArray(),
        disabled: allFieldsDisabled
    }
});

const getBankFields = (allFieldsDisabled) => new OrderedMap({
    "bank_details.account_type": {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Account Type",
        options: BANK_ACCOUNT_TYPES.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        disabled: true,
        defaultValue: 5,
        category: 3
    },
    "bank_details.account_holder_name": {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Account Holder Name",
        disabled: allFieldsDisabled,
        category: 3
    },
    "bank_details.account_number": {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.TEXT,
        label: "Account Number",
        disabled: allFieldsDisabled,
        category: 3
    },
    "bank_details.ifsc": {
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-30 mr-3perc",
        disabled: allFieldsDisabled,
        label: "Bank IFSC Code",
        showSearch: true,
        labelProp: "ifsc_code",
        category: 3
    },
    "bank_details.bank_branch": {
        type: INPUT_TYPES.OBJECT_TEXT,
        className: "form-field fb-30 mr-3perc",
        label: "Bank Branch",
        disabled: true,
        category: 3
    }
});

class CompanyAddForm extends React.Component {

    state = {
        userIds:
            this.props.spocValues && this.props.spocValues.size
                ? this.props.spocValues
                    .map(_ => _.id)
                    .mapEntries(([, v]) => [v, v])
                : new Map({}),
        userConfigs:
            this.props.spocValues && this.props.spocValues.size
                ? this.props.spocValues.toList()
                : new List([]),
        removed_users: [],
    };

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, { channel_products, sellers, anchor, primary_relationship_manager, industry, ...restValues}) => {
                const allAnchorId = [];
                const allIndustriesId = [];
                restValues.all_anchors?.map(item => allAnchorId.push(item.id));
                restValues.all_industries?.map(item => allIndustriesId.push(item.id));
                if (!err) {
                    const contact_detail = {
                        first_name: restValues.first_name,
                        last_name: restValues.last_name,
                        email: restValues.email,
                        phone: restValues.phone,
                        nature_of_association: restValues.nature_of_association
                    };
                    this.props.onValuesSubmit(
                        {
                            gstin: restValues.gstin,
                            type: restValues.type,
                            corporation_type: restValues.corporation_type,
                            channel_products: channel_products && channel_products.map(_ => _.id),
                            sellers: sellers && sellers.map(_ => _.id),
                            is_also_anchor: restValues.is_also_anchor === "true" ? true : false,
                            is_anchor_aligned: restValues.is_anchor_aligned === "true" ? true : false,
                            anchor: restValues.is_also_anchor === "true" ? undefined : anchor && anchor.id,
                            primary_relationship_manager: primary_relationship_manager && primary_relationship_manager.id,
                            industry: industry && industry.id,
                            contact_detail,
                            bank: restValues.bank == 0 ? null : restValues.bank,
                            all_anchors: allAnchorId,
                            all_industries: allIndustriesId,
                            additional_product_applicable: restValues.additional_product_applicable
                        }
                    );
                }
            });
        }
    };

    formatData = (data) => {
        if(data) {
            return data.map(_ => {
                return {
                    ..._,
                    name: `${_.name} (${_.gstin})`
                };
            });
        }
        return data;
    }

    formatIndustryData = (data) => {
        const myArrayFiltered = data.filter((el) => {
            return this.props.form.getFieldsValue().all_industries.some((f) => {
                return f.id === el.id && f.name === el.name;
            });
        });
        return myArrayFiltered;
    }

    formatPrimaryAnchorData = () => {
        let data = this.props.form.getFieldsValue().all_anchors;
        const filteredProgAnchorData = [];
        data && data.map(item => {
            if(item?.industry?.id === this.props.form.getFieldsValue().industry.id){
                filteredProgAnchorData.push(item);
            }
        });
        return filteredProgAnchorData;
    }

    formFields = getFormFields({
        gstinValidator: this.props.gstinValidator,
        allFieldsDisabled: this.props.loading,
        gstinDisabled: this.props.gstinDisabled
    });

    bankFormFields = getBankFields(this.props.loading);
    userFormFields = getUserDetails(this.props.loading);
    basicDetailsFields = getBasicDetails({
        formatSellerData: this.formatData,
        allFieldsDisabled: this.props.loading,
        getChannelProducts: this.props.fetchChannelProducts,
        salesManagers: this.props.fetchSalesManagers,
        fetchIndustryTypes: this.props.fetchIndustryTypes,
        formatIndustryData: this.formatIndustryData,
        formatPrimaryAnchorData: this.formatPrimaryAnchorData
    });

    ifscLookup = (str) =>
        CompanyService.ifscLookup(str).then(({ data }) => ({
            data: data.results
        }));

    getValueFromObject = bankBranch => {
        if (!bankBranch) {
            return null;
        }
        return bankBranch.name;
    };
    setBankBranchName = branch => {
        this.props.form.setFieldsValue({
            "bank_details.bank_branch": branch
        });
    };

    toggleFormGrid = (action = "ADD", id) => {
        const { userIds } = this.state;
        let removed_users = this.state.removed_users;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                userIds: userIds.set(newID, newID)
            });
            break;
        case "REMOVE": {
            removed_users.push(id);
            this.setState({
                userIds: userIds.filter(_ => _ !== id),
                removed_users: removed_users
            });
            break;
        }
        default:
        }
    };


    getCompanyForm = () => (
        <Card className={"no-shadow border-none"}>
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100"}>
                {this.formFields.map((field, fieldName) => {
                    field.disabled = this.props.disableFields;
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName)
                    )();
                }).toList()}
            </div>
        </Card>
    );

    onChangeField = (e) => {
        this.setState({
            checked: e.target.checked
        });
    }

    getBasicDetails = (companyType) => (
        <Card className={"no-shadow border-none"}>
            <div className={"d-flex flex-row flex-wrap w-100"}>
                {this.basicDetailsFields.filter((_, key) => {
                    if(!companyType || Number(companyType) === 1) {
                        return !["anchor", "sellers", "is_also_anchor", "all_industries", "all_anchors"].includes(key);
                    } else if(Number(companyType) === 2) {
                        return !["sellers", "bank", "is_also_aligned"].includes(key);
                    } else if(Number(companyType) === 3) {
                        return !["anchor", "is_also_anchor", "all_industries", "all_anchors", "industry", "is_also_aligned"].includes(key);
                    } else {
                        return _;
                    }
                }).map((field, fieldName) => {
                    field.disabled = this.props.disableFields;
                    if(fieldName === "is_also_anchor"){
                        field.onChange = this.setIsAlsoAnchor;
                    }
                    if(fieldName === "anchor") {
                        let is_also_anchor = this.props.form.getFieldValue("is_also_anchor");
                        if(is_also_anchor == "true") {
                            field.disabled = true;
                            field.rules = [];
                        } else {
                            if(this.props.form.getFieldsValue().industry?.id && this.props.form.getFieldsValue().all_industries && this.props.form.getFieldsValue().all_industries.length > 0 && this.props.form.getFieldsValue().all_anchors && this.props.form.getFieldsValue().all_anchors.length > 0){
                                field.disabled = false;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field Required"
                                    }
                                ];
                            }else{
                                field.disabled = true;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field Required"
                                    }
                                ];
                            }
                        }
                    }
                    if(fieldName === "all_anchors"){
                        let is_also_anchor = this.props.form.getFieldValue("is_also_anchor");
                        if(is_also_anchor == "true"){
                            field.disabled = true;
                            field.rules = [];
                        }else{
                            if(this.props.form.getFieldsValue().all_industries && this.props.form.getFieldsValue().all_industries.length > 0){
                                field.disabled = false;
                                field.onSearch = this.fetchAnchorList;
                                field.onChange = this.setAllAnchorList;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field Required"
                                    }
                                ];
                            }else {
                                field.disabled = true;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field Required"
                                    }
                                ];
                            }
                        }
                    }
                    if(fieldName === "industry"){
                        if(Number(companyType) === 1){
                            field.disabled = false;
                            field.onChange = this.setIndustryAndAnchor;
                            field.rules = [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ];
                        }else{
                            if(this.props.form.getFieldsValue().all_industries && this.props.form.getFieldsValue().all_industries.length > 0){
                                field.disabled = false;
                                field.onChange = this.setIndustryAndAnchor;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field Required"
                                    }
                                ];
                            }else{
                                field.disabled = true;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field Required"
                                    }
                                ];
                            }
                        }
                    }
                    if(fieldName === "all_industries"){
                        field.onChange = this.setAllIndustries;
                        field.rules = [
                            {
                                required: true,
                                message: "Field Required"
                            }
                        ];
                    }
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName)
                    )();
                }).toList()}
            </div>
        </Card>
    )

    setAllIndustries = (data) => {
        this.props.form.setFieldsValue({
            "all_industries": data,
            "all_anchors": [],
            "industry": null,
            "anchor": null
        });
    }

    setAllAnchorList = (data) => {
        this.props.form.setFieldsValue({
            "all_anchors": data,
            "industry": null,
            "anchor": null
        });
    }

    setIsAlsoAnchor = (data) => {
        if(data.target.value == "true"){
            this.props.form.setFieldsValue({
                "anchor": null,
                "all_anchors": [],
                "is_also_anchor": data.target.value,
            });
        }else{
            this.props.form.setFieldsValue({
                "is_also_anchor": data.target.value,
            });
        }
    }

    fetchAnchorList = (str) => {
        let industryIdList = [];
        this.props.form.getFieldsValue().all_industries.map((item) => {
            industryIdList.push(item.id);
        });
        return CompanyService.getCompanyProfilesFilterList(COMPANY_TYPES.get("Anchor"), str, industryIdList);
    }

    setIndustryAndAnchor = industry => {
        this.props.form.setFieldsValue({
            "industry": industry,
            "anchor": []
        });
    }

    getUserDetailsForm = () => (
        <Card className={"no-shadow border-none"}>
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100"}>
                {this.userFormFields.map((field, fieldName) => {
                    field.disabled = this.props.disableFields;
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName)
                    )();
                }).toList()}
            </div>
        </Card>
    )

    getBankDetailsForm = () => (
        <Card className={"no-shadow border-none"}>
            <div className={"d-flex flex-row align-items-center flex-wrap w-100"}>
                {this.bankFormFields.map((field, fieldName) => {
                    if(fieldName === "bank_details.account_type") {
                        field.disabled = true;
                    } else {
                        field.disabled = this.props.disableFields;
                    }
                    if(fieldName === "bank_details.ifsc") {
                        field.onSearch = this.ifscLookup;
                        field.onSelect = this.setBankBranchName;
                    }
                    if(fieldName === "bank_details.bank_branch") {
                        field.getValueFromObject = this.getValueFromObject;
                    }
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName)
                    )();
                }).toList()}
            </div>
        </Card>
    )

    render() {
        const companyType = this.props.form.getFieldValue("type");
        return (
            <Form onSubmit={this.onValuesSubmit}>
                <div className={"form-row align-items-center"}>    
                    <div className={"w-100 pt-10"}>
                        <h3 className={"pt-5 pb-5"}>{"Add Company"}</h3>
                        {this.getCompanyForm()}
                    </div>
                    <div className={"w-100 pt-10"}>
                        <h3 className={"pt-5 pb-5"}>{"Basic Details"}</h3>
                        {this.getBasicDetails(companyType)}
                    </div>
                    <div className={"w-100 pt-10"}>
                        <h3 className={"pt-5 pb-5"}>{"Applicant Details"}</h3>
                        {this.getUserDetailsForm()}
                    </div>
                </div>
                {!this.props.disableFields ? (
                    <div className={"d-flex flex-row-reverse"}>
                        <Form.Item>
                            <Button type="primary" className={"mt-10"} htmlType={"submit"}>{this.props.loading ? <Icon type={"loading"} /> : null}Submit</Button>
                        </Form.Item>
                    </div>
                ) : null}
            </Form>
        );
    }
}

CompanyAddForm.propTypes = {
    form: PropTypes.object,
    companyValues: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    gstinValidator: PropTypes.object,
    gstinDisabled: PropTypes.bool,
    fetchChannelProducts: PropTypes.func,
    loading: PropTypes.bool,
    spocValues: PropTypes.array,
    bankDetails: PropTypes.object,
    disableFields: PropTypes.bool,
    fetchSalesManagers: PropTypes.func,
    detail: PropTypes.object,
    fetchIndustryTypes: PropTypes.array
};

CompanyService.defaultProps = {
    disableFields: false
};

export default Form.create({})(CompanyAddForm);
